<template>
<div data-component="ModalDialog.vue" class="[ modal-dialog ]" :class="{ 'is-visible': ExternalVisible, 'is-autoclose': Autoclose, 'is-desktop': ScreenSize > 1 }" @wheel.stop.prevent @touchstart.stop="LogEvent" @click="Toggle" @animationend="OnAnimationEnd" @mousewheel.stop>
	<div v-if="InternalVisible" ref="modal" class="[ modal-dialog-wrapper ]" :style="Style" @wheel.stop @click.stop>
		<div
			class="[ modal-dialog-content ] relative" :class="ContentClass"
		>
			<slot/>
		</div>
		<slot name="footer"/>
	</div>
</div>
</template>

<script lang="ts">
// @vuese
// Komponent odpowiedzialny za wyświetlenie okna dialogowego.
// @group Base Components
export default {
	name: 'ModalDialog',
	props: {
		Autoclose: {
			type: Boolean,
			default: false,
		},
		Visible: {
			type: Boolean,
			default: false,
		},
		BackOnClick: {
			type: Boolean,
			default: false,
		},
		CloseOnBackdropClick: {
			type: Boolean,
			default: false,
		},
		Position: {
			type: Object,
			default: () => ({}),
		},
		ContentClass: {
			type: String,
			default: '',
		},
	},
	emits: ['open', 'toggle', 'OnOverlayClick', 'close'],
	data() {
		return {
			InternalVisible: false,
			ExternalVisible: false,
			BackdropClicked: false,
		};
	},
	computed: {
		Style() {
			if (Object.keys(this.Position).length > 0) {
				return {
					...this.Position,
					position: 'absolute',
				};
			}

			return {};
		},
	},
	watch: {
		Visible: {
			handler(v) {
				this.$emit('open');
				window.setTimeout(() => {
					if (v) {
						this.InternalVisible = true;
						this.ExternalVisible = true;
						this.BackdropClicked = false;
					} else {
						this.ExternalVisible = false;
					}
				}, 300);
			},
			immediate: true,
		},
	},
	methods: {
		LogEvent(e) {
			if (e.target.matches('.modal-dialog') || e.target.scrollHeight < e.target.offsetHeight) {
				// e.preventDefault();
			}
			// e.stopPropagation();
		},
		Toggle() {
			this.$emit('toggle');
			if (this.BackOnClick && !this.BackdropClicked) {
				this.BackdropClicked = true;
				window.history.back();
			}
			if (this.CloseOnBackdropClick && !this.BackdropClicked) {
				this.BackdropClicked = true;
				this.ExternalVisible = false;
			}
			this.$emit('OnOverlayClick');
		},
		OnAnimationEnd($event) {
			const $target = $event.target;
			const { animationName } = $event;

			if (this.Autoclose) {
				if (animationName.startsWith('modal-in')) {
					$target.classList.add('is-staying');
				}
				if (animationName.startsWith('hold')) {
					this.ExternalVisible = false;
					$target.classList.remove('is-staying');
				}
			}

			if (animationName.startsWith('modal-out')) {
				this.InternalVisible = false;
				this.$emit('close');
			}
		},
	},
};
</script>

<style lang="scss">

@keyframes modal-in {
	from { opacity: 0; transform: translateY(40px); }
	to { opacity: 1; transform: translateY(0); }
}

@keyframes modal-out {
	from { opacity: 1; transform: translateY(0); }
	to { opacity: 0; transform: translateY(40px); }
}

@keyframes hold {
	from { opacity: 1; }
	to { opacity: 1; }
}

.is-staying {
	animation: hold 0.9s !important;
}

.modal-dialog {
	position: fixed;
	z-index: 2048;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: rgba(0, 0, 0, 0.15);
	transition: opacity 0.15s ease-in;

	.modal-dialog-wrapper {
		overflow: auto;
		max-height: 90%;
		animation: modal-in 0.3s ease-in-out;
	}

	.modal-dialog-content {
		overflow: hidden;
		overflow: hidden;
		max-width: 100%;
		background: var(--white);
		border-radius: 8px;
		box-shadow: 0 10px 24px 0 rgba(0, 0, 0, 0.16);
	}

	&:not(.is-visible) {
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.15s ease-out 0.3s;

		.modal-dialog-wrapper {
			animation: modal-out 0.3s ease-in-out;
		}
	}
}

.is-dialog {
	.modal-dialog-content {
		width: calc(100vw - 40px);
		max-width: 28rem;
	}
}

.modal-dialog.is-from-bottom:not(.is-desktop) {
	justify-content: flex-end;

	.modal-dialog-wrapper,
	.modal-dialog-content {
		width: 100%;
		max-width: 100%;
	}
}

.is-submit-complete {
	display: flex;
	width: 304px;
	height: 192px;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 32px;
	text-align: center;
	&--larger{
		width: 600px;
		height: 300px;
	}
}

.modal-dialog.is-fullscreen {
	.modal-dialog-wrapper {
		width: 100%;
		height: 100%;
		max-height: 100%;
	}

	.modal-dialog-content {
		overflow: auto;
		width: 100%;
		max-width: 100%;
		height: 100%;
		border-radius: 0;
	}
}

.infotip-dialog .modal-dialog-content {
	padding: 1rem;
	border-left: 4px solid var(--info);
}

</style>
